const driverShifts = {
  driverShifts: 'Fahrerschichten',

  driverLink: 'URL der Fahrer-App',

  filters: {
    areas: 'Zonen',
    drivers: 'Fahrer',
    suppliers: 'Anbieter',
    vehicles: 'Fahrzeuge',
    locations: 'Standorte',
    airportLocations: 'Flughafenstandorte',
    attributes: 'Eigenschaften',
  },

  calendarTypes: {
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
  },

  driverfilter: {
    all: 'Alle Fahrer',
    withShift: 'Fahrer mit Schichten',
    withoutShifts: 'Fahrer ohne Schichten',
  },

  header: {
    create: 'Erstellen',
    createMulti: 'Mehrere erstellen',
    import: 'Importieren',
    switchButton: {
      label: 'Sicht',
      table: 'Tabelle',
      calendar: 'Kalender',
    },
  },

  moreActions: {
    delete: 'Löschen',
  },
  toast: {
    error: {
      sameDate: 'Von-Datum und Bis-Datum dürfen nicht identisch sein',
      badResponse: '[Driver Shift] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  headerButtons: {
    createBtn: 'Erstellen',
    createMultiBtn: 'Erstellen mehrerer Schichten',
    deleteBtn: 'Löschen',
  },

  table: {
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    headers: {
      name: 'Fahrer',
      email: 'Fahrer',
      address: 'Adresse',
      firstTripDistance: 'Maximale Entfernung der 1. Fahrt',
      addrLon: 'Lon',
      addrLat: 'Lat',
      at: 'Erstellt am',
      by: 'Erstellt von',
      areas: 'Zonen',
      locations: 'Standorte',
      attributes: 'Eigenschaften',
    },
    cells: {
      name: {
        vehicle: 'Fahrzeug',
      },
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },

  create: {
    successToast: {
      message: 'Erfolgreiche Fahrerschicht erstellt!',
    },
    errorToast: {
      message: 'Fehler aufgetreten! Fahrerschicht konnte nicht erstellt werden',
    },

    multi: {
      successToast: {
        message: 'Erfolgreiche Fahrerschichten erstellen!',
      },
      errorToast: {
        message: 'Fehler! Wählen Sie einen gültigen Wochentag für die Fahrerschicht',
      },
    },
    modalAfter24: {
      header: 'Warnung',
      body: 'Schichten, die bereits 24 Stunden überschritten haben, können nicht geändert werden',
    },
    modalBefore24: {
      header: 'Warnung',
      body: 'Änderungen, die innerhalb von 24 Stunden nach einer bestehenden Schicht vorgenommen werden, müssen bestätigt werden. Bitte bestätigen Sie, um fortzufahren',
    },
  },

  update: {
    successToast: {
      message: '{{count}} Fahrerschichten erfolgreich aktualisiert',
    },
    errorToast: {
      message: 'Fehler aufgetreten! Fahrerschicht konnte nicht aktualisiert werden',
    },

    scopeModal: {
      title: 'Schicht aktualisieren',
      body: 'Möchten Sie diese Änderungen anwenden auf:',
      options: {
        single: 'Nur diese Schicht',
        thisAndFuture: 'Diese und alle zukünftigen Schichten',
        allEvents: 'Alle Schichten',
        allEventsSubtitle: 'Ohne vergangene Schichten',
      },
      update: 'Aktualisieren',
      cancel: 'Abbrechen',
    },

    formTabs: {
      informationTab: 'Information',
      historyTab: 'Geschichte',
    },
  },

  import: {
    title: 'Fahrerschichten hochladen',
  },

  delete: {
    scopeModal: {
      title: 'Schicht löschen',
      body: 'Welche Schichten möchten Sie löschen?',
      confirm: 'Löschen',
    },
    modalError: {
      header: 'Fehler aufgetreten',
      body: 'Aktualisierung nicht möglich',
    },
    modalSuccess: {
      header: 'Erfolg',
      body: ' - Shifts deleted successfully',
    },
  },

  modalRemoveConfirm: {
    header: 'Warnung!',
    bodySingle: 'Möchten Sie diese Schicht wirklich löschen?',
    bodyMultiple: 'Möchten Sie diese Schichten wirklich löschen?',
    confirmBtn: 'Löschen',
  },

  modalRemoveSingelConfirm: {
    header: 'Fahrerschicht löschen',
    body: 'Sie sind dabei, eine Fahrerschicht zu löschen',
  },

  form: {
    header: {
      createDriverShift: {
        title: 'Erstellen',
      },

      createMultipleDriverShift: {
        title: 'Mehrere erstellen',
      },

      updateDriverShift: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
        delete: 'Löschen',
      },
    },

    information: {
      details: {
        header: 'Fahrerdetails',
        fields: {
          driver: 'Fahrer',
          vehicle: '(Fahrzeug: {{currentVehicle}})',
        },
      },
      shiftDetails: {
        header: 'Schichtdetails',
        overnightShiftNote: 'Hinweis: Dies ist eine Nachtschicht',
        multiDriverTimezoneNote: 'Hinweis: Die Zeiten werden in der lokalen Zeitzone jedes ausgewählten Fahrers interpretiert',
        shiftDurationNote: 'Schicht darf nicht länger als 24 Stunden dauern',
        fields: {
          fromDate: 'Starten',
          toDate: 'Ende',
          template: 'Schichtvorlage',
          address: 'Adresse',
          firstTripDistance: 'Maximale Entfernung der 1. Fahrt',
          attributes: 'Eigenschaften',
          areas: 'Zonen',
          areasPriorityMode: {
            title: 'Modus',
            options: {
              allStops: 'Alle Haltestellen',
              firstPickDrop: 'Erste Abholung und Absetzen',
              legAOrigin: 'Leg A Origin',
            },
          },
          areasPriorityLevel: {
            title: 'Priorität',
            options: {
              low: 'Niedrig',
              medium: 'Medium',
              high: 'Hoch',
              strict: 'Strikt',
            },
          },
          vehicle: 'Aktuelles Fahrzeug',
          suppliers: 'Anbieter',
          allowSharedRides: 'Gemeinsame Fahrten zulassen',
          ignoreDropoffTime: 'Ignore Drop-Off Time',
          ignoreDropoffTimeOptions: {
            byDriverSettings: 'Nach Fahrereinstellungen',
            enabled: 'Aktiviert',
            disabled: 'Deaktiviert',
          },
          shiftBuffer: 'Shift Buffer',
        },
      },
      locationsSettings: {
        header: 'Standorteinstellungen',
        fields: {
          locations: 'Standorte',
          enableInBetweenRides: 'Zwischenfahrten aktivieren',
        },
      },
    },

    validations: {
      drivers: {
        required: 'Fahrer sind erforderlich',
        drivers: '',
      },
      driver: {
        required: 'Fahrer ist erforderlich',
        driver: '',
      },
      start: {
        required: 'Start ist erforderlich',
        start: '',
      },
      end: {
        required: 'Ende ist erforderlich',
        endMustBeAfterStart: 'Das Ende einer Schicht muss nach dem Beginn liegen.',
        end: '',
      },
      breakOutsideShift: 'Pausen müssen innerhalb der Schichtzeiten liegen',
    },
    select: 'Wählen',
    buttons: {
      addBreak: ',+ Pause hinzufügen',
    },
  },

  formMulti: {
    header: {
      createMultiDriverShift: {
        title: 'Neue Schichten mit mehreren Fahrern',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Schichten mehrerer Fahrer bearbeiten',
      },
    },

    information: {
      details: {
        header: 'Fahrerdetails',
        fields: {
          drivers: 'Fahrer',
        },
      },
      shiftDetails: {
        header: 'Schichtdetails',
        fields: {
          fromDate: 'Von Datum',
          toDate: 'Bis Datum',
          weeksDays: 'Wochentage',
          fromHour: 'Von Stunde',
          tohour: 'Bis Stunde',
          breakStart: 'Pausenstart',
          breakEnd: 'Pausenende',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Fahrer sind erforderlich',
      },
      driver: {
        required: 'Fahrer ist erforderlich',
      },
      start: {
        required: 'Start ist erforderlich',
      },
      end: {
        required: 'Ende ist erforderlich',
      },
    },
    select: 'Wählen',
  },

  totalDriverShifts: 'Fahrerschichten insgesamt',

  calendarTable: {
    filters: {
      areas: 'Zonen',
      drivers: 'Fahrer',
      suppliers: 'Anbieter',
      attributes: 'Eigenschaften',
    },

    daily: {
      actions: {
        delete: 'Löschen',
        deleteTooltip: 'Der aktuelle Tag des Fahrers enthält keine Schichten',
      },
      noResults: 'Keine Ergebnisse gefunden',
      noResultsSubHeader: 'Wir können keinen Artikel finden, der Ihrer Suche entspricht',
      selectAll: 'Alles auswählen',
      selectAllPages: 'All {{limit}} items on this page are selected. ',
      btnSelectAllResults: ' Select all {{totalDrivers}} items',
      btnunselectAllResults: 'Auswahl löschen',
      totalDrivers: 'Gesamtzahl der Fahrer: {{total}}',
      totalShifts: 'Schichten insgesamt: {{total}}',
    },
    weekly: {
      actions: {
        delete: 'Löschen',
      },
    },
    emptyCell: {
      dayOff: 'Ruhetag',
    },
    headers: {
      driverName: 'Name',
      monday: 'Montag {{day}}',
      tuesday: 'Dienstag {{day}}',
      wednesday: 'Mittwoch {{day}}',
      thursday: 'Donnerstag {{day}}',
      friday: 'Freitag {{day}}',
      saturday: 'Samstag {{day}}',
      sunday: 'Sonntag {{day}}',
    },
  },
};

export default driverShifts;
